var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-base',[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid-x grid-margin-x grid-margin-y flex-dir-row-reverse"},[_c('div',{staticClass:"cell large-4 medium-5 small-12"},[_c('ui-form-contact')],1),_c('div',{staticClass:"cell large-8 medium-7 small-12"},[_c('ui-list')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }